// Module
var code = `<div
        class="alert-banner alert-banner--{{ type }}"
        [attr.role]="isCritical ? 'alert' : 'status'"
        [attr.aria-live]="isCritical ? 'assertive' : 'polite'"
>
    <svg
            class="alert-banner__icon"
            viewBox="0 0 24 24"
            width="24"
            height="24"
            aria-hidden="true"
            focusable="false"
            [ngSwitch]="type"
    >
        <!-- success: check in a filled circle -->
        <g *ngSwitchCase="'success'">
            <circle cx="12" cy="12" r="10" fill="currentColor" />
            <path d="M8 12.5l2.5 2.5 5-5.5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </g>
        <!-- error: exclamation in a filled circle -->
        <g *ngSwitchCase="'error'">
            <circle cx="12" cy="12" r="10" fill="currentColor" />
            <path d="M12 7v6" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" />
            <circle cx="12" cy="16.5" r="1.25" fill="#fff" />
        </g>
        <!-- warning: exclamation in a filled triangle -->
        <g *ngSwitchCase="'warning'">
            <path d="M12 3.2l9.3 16.1a1 1 0 0 1-.87 1.5H3.57a1 1 0 0 1-.87-1.5z" fill="currentColor" />
            <path d="M12 10v4.2" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" />
            <circle cx="12" cy="17.2" r="1.15" fill="#fff" />
        </g>
        <!-- info: "i" in a filled circle -->
        <g *ngSwitchDefault>
            <circle cx="12" cy="12" r="10" fill="currentColor" />
            <path d="M12 11v5" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" />
            <circle cx="12" cy="7.75" r="1.25" fill="#fff" />
        </g>
    </svg>

    <div class="alert-banner__body">
        <span *ngIf="title" class="alert-banner__title">{{ title }}</span>
        <div class="alert-banner__message"><ng-content></ng-content></div>
    </div>

    <button
            *ngIf="dismissible"
            type="button"
            class="alert-banner__close"
            aria-label="Dismiss"
            (click)="dismiss()"
    >
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
            <path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
    </button>
</div>
`;
// Exports
module.exports = code;